module.exports = __webpack_public_path__ + "ipetbooking/admin/img/account.766ec71f.svg";